import { t } from 'i18next';
import { useAppSelector } from '../../../hook/useAppSelector';
import DetailsLayout from './DetailsLayout';
import { CashRegisterMode } from '../../../enum/CashRegisterMode';

interface CashRegisterDetailsProps {
  setShowDetails: (showDetails: boolean) => void;
  getDetails: () => void;
}

const CashRegisterDetails: React.FC<CashRegisterDetailsProps> = ({ setShowDetails, getDetails }) => {
  const cashRegisterDetails = useAppSelector((state) => state.cashRegisterDetails);
  const games = useAppSelector((state) => state.cashRegisterDetails.data?.Games);
  const operators = useAppSelector((state) => state.cashRegisterDetails.data.Operators);

  return (
    <DetailsLayout
      className="cash_register_details"
      title={t("cashRegister.table.details.cashRegisterDetails.header")}
      startState={cashRegisterDetails.data && cashRegisterDetails.data.StartState}
      endState={cashRegisterDetails.data && cashRegisterDetails.data.EndState}
      onClose={() => setShowDetails(false)}
      onSearch={getDetails}
      mode={CashRegisterMode.CASH_REGISTER_DETAILS}
      aplicationGames={games || []}
      operators={operators}
    />
  );
};

export default CashRegisterDetails;
